<template>
  <div id="content">
      <div class="producttwobg">
        <img src="./images/productbg.jpg" />
      </div>
    <div id="producttwo">

      <div class="producttwocenterdiv">
      
      <div class="producttwo">
        <ul>
          <li v-for="(p,i) in producttwos.Items"
              :key="p.ID">
              <a :href="'/#/producttwodetail/'+p.ID" target="_blank">
                
              <div class="producttwodetail">
                <div  :class="[{'producttwodetailleft':(i%2==0)},{'producttwodetailleftnone':(i%2==1)}]" >
<img :src="p.prod_image"
                   alt="" />
                </div>
                <div v-if="$i18n.locale=='en'" class="producttwodetailright" >
            <span class="leTitle">{{p.prod_enname}}</span>
            <span class="leTitleInfo"
               >{{p.prod_enRemark}}</span>
                  </div>
<div class="producttwodetailright"  v-else>

            <span class="leTitle">{{p.prod_name}}</span>
            <span class="leTitleInfo"
               >{{p.prod_remark}}</span>
</div>
                <div  :class="[{'producttwodetailleft':(i%2==1)},{'producttwodetailleftnone':(i%2==0)}]" >
<img :src="p.prod_image"
                   alt="" />
                </div>
</div>
</a>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <div class="m b10">&nbsp;</div>
    </div>
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: "producttwo",
  data () {
    return {
      classs: [],
      producttwos: {},
      page_index: 1,
      big_class: 0,
      keyword: 0,
      keywordinfo: {},
    };
  },
  created () {
    this.big_class = this.$route.params.id
    this.keyword = this.$route.params.key
  },
  mounted () {
    // 使用
    const keywordinfo = { 'bigclassid':2 };
    const productparam = { page_index: 1, page_size: 90, keyword: JSON.stringify(keywordinfo) }; // 参数
    fetch.post("/api/ApiProduct/QueryPageProductList", productparam).then(
      (res) => {
        this.producttwos = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    //this.changePage(1)
    // const producttwoparam = { page_index: this.page_index, key: this.keyword }; // 参数
    // if (this.big_class != 0) {
    //   producttwoparam.big_class = this.big_class;
    // }
    // fetch.post("/api/Apiproducttwo/QueryPageproducttwoList", producttwoparam).then(
    //   (res) => {
    //     this.producttwos = res;
    //   },
    //   (error) => {
    //     alert(JSON.stringify(error));
    //   }
    // );
  },
  methods: {
    changeclass (cl) {
      this.big_class = cl;
      this.changePage(1);
    },
    changePage (pageIndex) {
      this.keywordinfo = { 'bigclassid':1,'smallclassid': this.big_class,'type': this.big_class, 'keyword': this.keyword };
      const producttwoparam = { page_index: pageIndex, page_size: 9, keyword: JSON.stringify(this.keywordinfo) }; // 参数
      if (this.big_class != 0) {
        producttwoparam.big_class = this.big_class;
      }
      fetch.post("/api/ApiProduct/QueryPageProductList", producttwoparam).then(
        (res) => {
          this.producttwos = res;
          window.scrollTo(0, 0)
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    },
  },

  scrollToBottom: function () {
    alert('scrollToBottom')
  }
};
</script>

<style>
#producttwo {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f5f5f5;
}
.producttwobg{
  margin: 0px;
padding: 0px;
height: 300px;
}
.producttwobg img{
  margin: 0px;
padding: 0px;
}
.producttwocenterdiv {
  width: 1400px;
  display: flex;
  margin: 0 auto;
}
/* .nav_1 {
  flex:0 0 24%;
  margin: 30px 1% auto;
  text-align: left;
} */
.producttwoNav{
  background-color: orange;
  color: white;
  font-weight: bolder;
  font-size: 30px;
  width: 100%;  line-height: 80px;
  text-indent: 20px;
  position: relative;border-radius: 20px 0 0 0;
}

/* .nav_1 a {
  display: block;
  float: left;
  text-align: left;
  font-size: 16px;
  color: #333;
  width: 100%;  
  line-height: 60px;
  background: white;
  border-bottom: 1px #dbdbdb solid;
  text-indent: 20px;
}
.nav_1 a:hover {
  background: #00a0e9;
  color: #fff;
  border-bottom: 3px #028fcf solid;
}
.nav_1 a.on {
  background: #00a0e9;
  color: #fff;
  border-bottom: 3px #028fcf solid;
} */

.producttwo {
  flex:0 0 100%;
  overflow: hidden;
}
.producttwo ul {
  margin-top: 20px;
}
.producttwo li {
  float: left;
  width: 100%;
  display: inline-block;
  background-color: white;
  height: 431px;overflow: hidden;position: relative;
}
.producttwo li img {
  display: block;
  border: 0;
  width: 100%;
  height: 431px;
  overflow: hidden;position: relative;
}
.producttwo li a img{width:100%;height: 431px;transition: .4s all;cursor: pointer;}
.producttwo li a:hover > img{transform: scale(1.3);}
.producttwo li .leTitle {
  font-size: 30px;
  font-weight: bolder;
  padding: 30px;
  color: darkorange;

}
.producttwo li .leTitleInfo {
  color: darkorange;
  width: 90%;
  font-size: 16px;
  margin: 20px;
}

.producttwo li span {
  display: block;
  text-align: left;
  width: 100%;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #333;
  margin-top: 4px;
}
.producttwo li em {
  display: block;
  text-align: right;
  font-style: normal;
  font-size: 12px;
  line-height: 24px;
}
.producttwo li em a {
  color: #999;
}
.producttwo li:hover {
  background: #00a0e9;
}
.producttwo li:hover span {
  color: #fff;
}
.producttwo li:hover em a {
  color: #fff;
}

.page {
  width: 1100px;
  margin: 40px auto;
  text-align: center;
  font-size: 12px;
  color: #333;
}
.page a {
  color: #333;
  padding: 7px 12px;
  border: 1px #ccc solid;
  margin: 0px 2px;
}
.page a:hover {
  border: 1px #01a4e9 solid;
  background: #01a4e9;
  color: #fff;
}
.page span {
  padding: 7px 12px;
  background: #01a4e9;
  color: #fff;
  border: 1px #01a4e9 solid;
  margin: 0px 2px;
}
.producttwodetail{
  display: flex;
  width: 100%;
}
.producttwodetailleft{
  width: 50%;overflow: hidden;
}
.producttwodetailleftnone{
  display: none;
  width: 50%;
}
.producttwodetailright{
  width: 50%;overflow: hidden;
}

.producttwodetailright a:hover > .morex {background-color:#4cc9f0;-webkit-box-shadow: 10px 10px 99px6px rgba(76,201,240,1);-moz-box-shadow: 10px 10px 99px 6pxgba(76,201,240,1);box-shadow: 10px 10px 99px6px rgba(76,201,240,1);}
.producttwodetailright a  .morex{ margin-top: 140px;}
</style>



// WEBPACK FOOTER //
// src/ProductTwo.vue